import React from 'react';
import { Rect, Ellipse } from 'react-konva';
import useNodeDimensionsOperations from 'components/canvas/hooks/use-node-dimensions-operations';
import { color } from 'styles/settings';
import { SurfaceNodeType } from 'graphql/types';

export interface MiniMapNodesProps {
  nodes: any[];
}

const defaultProps = {
  nodes: [],
};

function MiniMapNodes({ nodes }: MiniMapNodesProps) {
  const { getNodeDimensions } = useNodeDimensionsOperations();

  return (
    <>
      {nodes?.map((node) => {
        const dimensions = getNodeDimensions(node);

        if (node.type === 'BACKGROUND') {
          return (
            <Rect
              id={node.id}
              key={`node-${node.id}`}
              {...dimensions}
              x={node?.position?.x}
              y={node?.position?.y}
              stroke={color.brand.blue}
              fill={color.neutral.blackWithOpacity(0.1)}
              strokeWidth={10}
              draggable={false}
            />
          );
        }

        const props = {
          id: node.id,
          key: `node-${node.id}`,
          ...dimensions,
          x: node?.position?.x,
          y: node?.position?.y,
          fill: color.brand.blue,
          draggable: false,
        };

        if (node.type === SurfaceNodeType.SubSurface) {
          return <Ellipse radiusX={1} radiusY={1} {...props} />;
        }

        return <Rect {...props} />;
      })}
    </>
  );
}

MiniMapNodes.defaultProps = defaultProps;

export default MiniMapNodes;
